/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { EntityStatus } from './entityStatus';


export interface SmsClient { 
    anqClientId: number;
    creatorId?: string;
    email?: string;
    fullname?: string;
    userChannelType: number;
    systemId?: string;
    password?: string;
    defaultRouteName?: string;
    firstName?: string;
    isTelco: boolean;
    lastName?: string;
    username?: string;
    apiKey?: string;
    entityStatus: EntityStatus;
    dateCreated: Date;
}
